/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./nCurrencyTwo.vue?vue&type=template&id=3b7b44e4&scoped=true"
import script from "./nCurrencyTwo.vue?vue&type=script&lang=js"
export * from "./nCurrencyTwo.vue?vue&type=script&lang=js"
import style0 from "./nCurrencyTwo.vue?vue&type=style&index=0&id=3b7b44e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b44e4",
  null
  
)

export default component.exports